import $ from 'jquery';

const defaults = {
  parentSelector: 'li.menuparent',
};

export default class Menu {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.$toggles = this.addToggles();
    this.click = this.click.bind(this);
    this.displayActiveMenus();
    this.listen();
  }

  addToggles() {
    return this.$element.find(this.settings.parentSelector).each((i, element) => {
      const $btn = $('<button class="menu-toggle">Toggle Menu</button>');
      $btn.appendTo(element).on('click', this.click);
    });
  }

  click(event) {
    $(event.currentTarget, this.element).parent('li').toggleClass('menu-expanded');
  }

  displayActiveMenus() {
    $('.active-trail', this.element).addClass('menu-expanded');
  }

  listen() {
    this.$toggles.on('click', this.onClick);
  }
}
